import type { FC } from "react";

import round from "lodash/round";
import { CHART_COLORS } from "src/ui/colors";
import { chartFontStyles } from "src/components/charts/chart-utils";

type LabelProps = {
  viewBox?: { x: number; y: number; width: number; height: number };
  offset?: number;
  parentViewBox?: boolean;
  value?: number;
};

export const Label: FC<LabelProps> = ({
  offset = 0,
  parentViewBox,
  value,
  viewBox = { x: 0, y: 0, width: 0, height: 0 },
}) => {
  if (value === undefined) {
    return null;
  }

  const fontStyles = {
    ...chartFontStyles,
    // Additional custom text styles here
    fill: CHART_COLORS.gray.text,
    color: CHART_COLORS.gray.text,
    fontWeight: 500,
  };

  const { x, y, width, height } = viewBox;
  const verticalSign = height >= 0 ? 1 : -1;
  const verticalOffset = verticalSign * offset;

  const sizeAttrs = parentViewBox ? { width, height } : {};
  const labelText = `${round(value * 100, 2)}%`;

  const textWidth = labelText.length * 8 + 16;
  const textHeight = 24;

  const rectX = x + width / 2 - textWidth / 2;
  const rectY = y + verticalOffset + height + (value < 0.1 ? -36 : -17); // centers the rectangle and text vertically

  const positionAttrs = {
    x: x + width / 2,
    y: y + verticalOffset + height + (value < 0.1 ? -20 : 0),
    textAnchor: "middle" as const,
    fill: CHART_COLORS.gray.text,
    ...sizeAttrs,
  };

  return value || value === 0 ? (
    <>
      <rect
        x={rectX}
        y={rectY}
        width={textWidth}
        height={textHeight}
        rx={6}
        fill="white"
        stroke={CHART_COLORS.gray.divider}
        strokeWidth={1}
        style={{
          pointerEvents: "none",
        }}
      />
      <text {...positionAttrs} {...fontStyles}>
        {labelText}
      </text>
    </>
  ) : null;
};
